"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterAmount = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const validator_1 = __importDefault(require("validator"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const svg_selector_1 = require("../../../../assets/svg-selector");
const tonapi_1 = require("../../../../logic/tonapi");
const enter_amount_module_css_1 = __importDefault(require("./enter-amount.module.css"));
const use_media_query_1 = require("../../../../utils/use-media-query");
const EnterAmount = (props) => {
    const [amount, setAmount] = (0, react_1.useState)('0');
    const [cardNumber, setCardNumber] = (0, react_1.useState)('');
    const [mail, setMail] = (0, react_1.useState)('');
    const tonApi = new tonapi_1.TonApi();
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    const inputRef = (0, react_1.useRef)(null);
    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    (0, react_1.useEffect)(() => {
        if (firstRender) {
            console.log('FIRST RENDER INPUT');
            setFirstRender(false);
            focusInput();
        }
    });
    console.log('cardNumber', cardNumber);
    const handleCardNumberChange = (event) => {
        const sanitizedInput = event.target.value.replace(/\D/g, '');
        const truncatedInput = sanitizedInput.slice(0, 16);
        const formattedInput = truncatedInput.replace(/(\d{4})/g, '$1 ').trim();
        setCardNumber(formattedInput);
    };
    const [isvalidAmount, setisValidAmount] = (0, react_1.useState)(true);
    const [minTonAmount, setMinTonAmount] = (0, react_1.useState)('25');
    const isMobile = (0, use_media_query_1.useMediaQuery)(340);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dynamicMaxWidth = `${Math.max((amount.length * 18), 21)}px`;
    const TgObj = sdk_1.default;
    const validateButton = (amount) => {
        const amountValue = parseFloat(amount.replace(',', '.'));
        return (!isNaN(amountValue)
            && /^\d+(\.\d+)?$/.test(String(amountValue))
            && amountValue >= 0.00001
            && amountValue <= 1500000);
    };
    const sanitizedAmount = amount.replace(',', '.');
    (0, react_1.useEffect)(() => {
        props.setSendData({ ...props.sendData, amount: sanitizedAmount, cardNumber: cardNumber.replace(/\s/g, ''), customerEmail: mail });
    }, [amount, sanitizedAmount, cardNumber, mail]);
    (0, react_1.useEffect)(() => {
        if (props.position !== 1 || !props.sendData.availableBalance)
            return;
        TgObj.MainButton.show();
        if (!validateButton(sanitizedAmount)
            || !/^\d+(\.\d+)?$/.test(sanitizedAmount)
            || !isvalidAmount
            || ((props.sendData.token === 'TON') && (cardNumber.replace(/\s/g, '').length < 16))
            || ((props.sendData.token === 'TON') && (!mail || !(validator_1.default.isEmail(mail))))) {
            TgObj.MainButton.disable();
            TgObj.MainButton.text = t('send.enter-amount-position.enter-amount');
            TgObj.MainButton.color = '#424B56';
        }
        else {
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('send.enter-amount-position.proceed');
        }
        const handleBtnClick = () => {
            // props.setSendData({ ...props.sendData, amount: sanitizedAmount })
            props.setPosition(2);
            TgObj.MainButton.offClick(handleBtnClick);
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [amount, props.position === 1, props.sendData.availableBalance, props.sendData, cardNumber]);
    (0, react_1.useEffect)(() => {
        const getMinTonAmount = async () => {
            if (props.sendData.token === 'TON') {
                const priceTokenRub = await tonApi.getTokenPrice(props.sendData.tokenAddress, 'rub');
                if (!priceTokenRub) {
                    return;
                }
                const minTon = ((5000 / Number(priceTokenRub.rates[props.sendData.tokenAddress].prices.RUB)) + 1).toFixed(0); // from 5000 RUB
                setMinTonAmount(minTon);
            }
        };
        getMinTonAmount();
    }, [props.sendData.tokenAddress, props.sendData.token]);
    (0, react_1.useEffect)(() => {
        const getCurrentAmountValid = async () => {
            if (props.sendData.token === 'TON') {
                if (Number(amount) >= Number(minTonAmount)) {
                    setisValidAmount(true);
                }
                else {
                    setisValidAmount(false);
                }
            }
            if (props.sendData.token !== 'TON') {
                if (Number(amount) > (Math.floor(Number(props.availableAmount) * 100) / 100)) {
                    setisValidAmount(false);
                }
                else {
                    setisValidAmount(true);
                }
            }
        };
        getCurrentAmountValid();
    }, [props.sendData.token, minTonAmount, props.availableAmount, amount]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: enter_amount_module_css_1.default.modalTitle, children: t('send.enter-amount') }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.amountContainer, children: [(0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.usdContainer, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: enter_amount_module_css_1.default.youPay, children: t('trans-detail.you-send2') }), props.rubAmount && props.rubAmount.length !== 0 && amount.length !== 0 && !isNaN(parseFloat(amount))
                                && (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: enter_amount_module_css_1.default.usdAmount, children: ["~ ", parseFloat(props.rubAmount).toLocaleString('ru', { style: 'currency', currency: 'RUB' })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.amountInner, onClick: focusInput, children: [(0, jsx_runtime_1.jsx)("input", { style: { maxWidth: dynamicMaxWidth }, ref: inputRef, className: `${enter_amount_module_css_1.default.amountInput} ${!isvalidAmount ? enter_amount_module_css_1.default.amountInputError : ''}`, value: amount, inputMode: "decimal", pattern: "[0-9]*[.,]?[0-9]*", onChange: (e) => {
                                    let inputValue = e.target.value.replace(/,/g, '.');
                                    inputValue = inputValue.replace(/^0+(?!$|\.)/, '');
                                    inputValue = inputValue.replace(/[^0-9.]+/, '');
                                    inputValue = inputValue.length === 0 ? '0' : inputValue;
                                    // const isValidInput = /^\d*\.?\d*$/.test(inputValue)
                                    const isValidInput = /^-?\d*\.?\d*$/.test(inputValue);
                                    if (isValidInput) {
                                        setAmount(inputValue);
                                    }
                                } }), (0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: `${enter_amount_module_css_1.default.token} ${!isvalidAmount ? enter_amount_module_css_1.default.amountInputError : ''}`, children: props.sendData.token })] }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.line }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.options, children: (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.option, children: (props.sendData.token === 'TON')
                                ? (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: enter_amount_module_css_1.default.optionText, children: [t('send.enter-amount-position.available'), " ", t('send.enter-amount-position.from'), " ", minTonAmount, " ", props.sendData.token] })
                                : (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: enter_amount_module_css_1.default.optionText, children: [t('send.enter-amount-position.available'), " ", Math.floor(Number(props.availableAmount) * 100) / 100, " ", props.sendData.token] }) }) })] }), props.sendData.token === 'TON' && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: `${enter_amount_module_css_1.default.amountContainer} ${enter_amount_module_css_1.default.cardContainer}`, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: enter_amount_module_css_1.default.formText, children: t('send.enter-amount-position.enter-card') }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.cardInputWrapper, children: [(0, jsx_runtime_1.jsx)("input", { type: "text", value: cardNumber, placeholder: "0000 0000 0000 0000", onChange: handleCardNumberChange, className: enter_amount_module_css_1.default.cardInput }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.cardIconWrapper, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'card' }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.cardInputWrapper, children: [(0, jsx_runtime_1.jsx)("input", { type: "email", value: mail, placeholder: "example@gmail.com", onChange: e => setMail(e.target.value), className: enter_amount_module_css_1.default.cardInput }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.cardIconWrapper, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'email' }) })] })] }) })] }));
};
exports.EnterAmount = EnterAmount;
